import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function OrderCancelPage() {
  return (
    <div
      data-testid="order-cancel-page"
      className="min-h-screen flex items-center justify-center bg-[#FDFBF7] px-4"
    >
      <div className="max-w-lg w-full bg-white rounded-2xl border border-[#E8E5DF] p-10 text-center">
        <p className="font-serif-display text-4xl">Payment cancelled</p>
        <p className="mt-3 text-[#5C625E]">
          No charge has been made. Your basket is still here when you're ready.
        </p>
        <Link to="/menu" className="inline-block mt-8">
          <Button className="bg-[#C05746] text-white hover:bg-[#A64A3C] rounded-full px-8">
            Back to menu
          </Button>
        </Link>
      </div>
    </div>
  );
}
